import { useState, useEffect } from 'react';
import { windowAvailable } from '../utils/client-detection';
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        if (!windowAvailable()) {
            return;
        }
        const mediaQueryList = window.matchMedia(query);
        const listener = (event) => {
            setMatches(event.matches);
        };
        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', listener);
        return () => {
            mediaQueryList.removeEventListener('change', listener);
        };
    }, [query]);
    return matches;
}
